module.exports = __webpack_public_path__ + "img/changelabel.9602978d.svg";